import * as Sentry from '@sentry/vue';

export function initSentry(Vue, router, config) {
  if (!config.VUE_APP_SENTRY_DSN) {
    console.info('🪶 Sentry inactif – aucune configuration DSN détectée');
    return;
  }
  const envMode = (config.VUE_APP_ENV_MODE || 'recette').toLowerCase();

  Sentry.init({
    Vue,
    dsn: config.VUE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0,               // ❌ pas de performance tracing
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*\/geocontrib\/api/,
    ],
    replaysSessionSampleRate: 0,       // ❌ pas d’enregistrement de sessions
    replaysOnErrorSampleRate: 0,       // ❌ pas d’enregistrement même en cas d’erreur
    sendDefaultPii: false,
    maxBreadcrumbs: 50,
    release: process.env.PACKAGE_VERSION || 'unknown',
    environment: envMode,
    beforeSend(event) {
      if (event.request) {
        if (event.request.headers) {
          delete event.request.headers.Authorization;
          delete event.request.headers.cookie;
          delete event.request.headers['X-CSRFToken'];
          delete event.request.headers['x-csrftoken']; // certains navigateurs minifient en minuscules
        }
        if (event.request.url) {
          event.request.url = event.request.url.replace(/token=[^&]+/, 'token=[REDACTED]');
        }
        if (event.request.data) {
          // Nettoyer les champs sensibles connus
          ['password', 'email', 'token', 'csrfmiddlewaretoken'].forEach(k => {
            if (event.request.data[k]) event.request.data[k] = '[REDACTED]';
          });
        }
      }
      return event;
    }
  });

  // Vérification réelle du statut Sentry et affichage en console
  const enabled = Sentry.isInitialized();
  console.info(
    enabled
      ? `🪶 Sentry initialisé avec succès (${envMode})`
      : '⚠️ Sentry configuré mais non initialisé'
  );
}